// create enum for all permissions
export enum VZ_PERMISSIONS {
  "all" = "all",

  "APPLICATIONS_EMAIL" = "VYZOR:APPLICATIONS:EMAIL",
  "APPLICATIONS_SMS" = "VYZOR:APPLICATIONS:SMS",
  "APPLICATIONS_SCHEDULER" = "VYZOR:APPLICATIONS:SCHEDULER",

  "BUSINESS_SITE" = "VYZOR:BUSINESS:SITE",
  "BUSINESS_CLIENT" = "VYZOR:BUSINESS:CLIENT",
  "BUSINESS_LOCATIONS" = "VYZOR:BUSINESS:LOCATIONS",

  "USERS_ROLES" = "VYZOR:USERS:ROLES",
  "USERS_USERPERMISSIONS" = "VYZOR:USERS:USER PERMISSIONS",
  "USERS_PERMISSIONS" = "VYZOR:USERS:PERMISSIONS",
  "USERS_USERS" = "VYZOR:USERS:USERS",

  "INTEGRATIONS_EMAILMANAGER" = "VYZOR:INTEGRATIONS:EMAIL MANAGER",
  "INTEGRATIONS_DEVICES" = "VYZOR:INTEGRATIONS:DEVICES",
  "INTEGRATIONS_SMSMANAGER" = "VYZOR:INTEGRATIONS:SMS MANAGER",

  "SETTINGS_LOOKUPCONFIGURATION" = "VYZOR:SETTINGS:LOOKUP CONFIGURATION",
  "SETTINGS_EVENTS" = "VYZOR:SETTINGS:EVENTS",

  "TEMPLATES_FORMS" = "VYZOR:TEMPLATES:FORMS",
  "TEMPLATES_TASKS" = "VYZOR:TEMPLATES:TASKS",
  "TEMPLATES_SECTIONS" = "VYZOR:TEMPLATES:SECTIONS",

  "DASHBOARD_PERFORMANCEREVIEW" = "VYZOR:DASHBOARD:PERFORMANCE REVIEW",
  "DASHBOARD_SITESOVERVIEW" = "VYZOR:DASHBOARD:SITES OVERVIEW",
  "DASHBOARD_USERSTATISTICS" = "VYZOR:DASHBOARD:USER STATISTICS",
}

export type CrudAction = "CREATE" | "READ" | "UPDATE" | "DELETE";
